

















import Component from "vue-class-component";
import { BaseRootPageComponent } from "@/components/BaseRootPageComponent";

import CoreAPI from "@/utils/core-api";
import * as modals from "@/utils/modals";

@Component
export default class Info extends BaseRootPageComponent {
  loading = false;
  totalConnections = "-";
  startTime = "-";
  version = "-";
  timeout?: number;

  async created() {
    this.setTitle("Info");

    await this.fetchInfo();
  }

  beforeDestroy() {
    clearTimeout(this.timeout);
  }

  timeSince(date: number) {
    // Just use total seconds for uptime, and display days / years
    const diffInMillis = new Date().getTime() - date;
    const seconds = Math.floor(diffInMillis / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const years = Math.floor(days / 365);

    if (years > 0) {
      return `${years}y ${days % 365}d ${hours % 24}h ${minutes % 60}m ${seconds % 60}s`;
    }
    if (days > 0) {
      return `${days}d ${hours % 24}h ${minutes % 60}m ${seconds % 60}s`;
    }
    if (hours > 0) {
      return `${hours}h ${minutes % 60}m ${seconds % 60}s`;
    }
    if (minutes > 0) {
      return `${minutes}m ${seconds % 60}s`;
    }
    return `${seconds}s`;
  }

  async fetchInfo() {
    try {
      this.loading = true;
      const info = await CoreAPI.getInfo();
      this.version = info.version;
      this.totalConnections = info.totalConnections;
      this.startTime = this.timeSince(Date.parse(info.startTime));

      // This keeps loading the info every 1 second as long as there hasn't been an error. If there's an error, stop
      // loading because the error probably hasn't gone away in 1 second
      //
      // This is here instead of using an interval because if the server is unreachable, it may take a few seconds for
      // the request to complete, in which case this method would have been called multiple times and would have opened
      // multiple error modals.
      this.timeout = setTimeout(() => this.fetchInfo(), 1000);
    } catch (error) {
      this.startTime = "-";
      this.version = "-";
      this.totalConnections = "-";

      if ((error as any).isNetworkError) {
        await modals.showLostConnectionModal(this.$bvModal);
      } else {
        await modals.showUnexpectedErrorModal(this.$bvModal);
      }
    } finally {
      this.loading = false;
    }
  }
}
